<template functional>
  <svg
    id="inlineLoaderRef"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    overflow="visible"
    fill="#172542"
    class="single-loader"
  >
    <defs><circle id="inline" r="6" cx="20" cy="50" /></defs>
    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#inline" x="0">
      <animate
        attributeName="opacity"
        values="0;1;0"
        dur="1s"
        begin="0s"
        repeatCount="indefinite"
      />
    </use>
    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#inline" x="20">
      <animate
        attributeName="opacity"
        values="0;1;0"
        dur="1s"
        begin="0.25s"
        repeatCount="indefinite"
      />
    </use>
    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#inline" x="40">
      <animate
        attributeName="opacity"
        values="0;1;0"
        dur="1s"
        begin="0.5s"
        repeatCount="indefinite"
      />
    </use>
    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#inline" x="60">
      <animate
        attributeName="opacity"
        values="0;1;0"
        dur="1s"
        begin="0.75s"
        repeatCount="indefinite"
      />
    </use>
  </svg>
</template>

<script>
export default {
  name: 'BaseLoader'
}
</script>
